export const lightTheme = {
  //main themes
  backgroundColor: "#f2f2f2",
  fontColor: "#000000",
  accentColor: "#1ebbd7",
  navDropShadow: "rgba(0, 0, 0, 0.2)",
  dropShadow: "rgba(0, 0, 0, 0.3)",
  //gallerypage svgs
  svgPrimaryColor: "#575a5b",
  svgSecondaryColor: "#111",
  //feedbackmodal colors
  inputBoxShadow: "rgba(0, 0, 0, 0.15)",
  inputFocusColor: "rgba(30, 187, 215, 0.6)",
};

export const darkTheme = {
  //main themes
  backgroundColor: "#222",
  fontColor: "#FFFFFF",
  accentColor: "#1ebbd7",
  navDropShadow: "rgba(0, 0, 0, 0.4)",
  dropShadow: "rgba(0, 0, 0, 0.7)",
  //gallerypage svgs
  svgPrimaryColor: "#b2babb",
  svgSecondaryColor: "#f2f2f2",
  //feedbackmodal colors
  inputBoxShadow: "rgba(0, 0, 0, 0.3)",
  inputFocusColor: "rgba(30, 187, 215, 0.5)",
};
